/* eslint-disable */

function loadGoogleTagManager(w,d,s,l,i) {

    w[l]=w[l]||[];
    w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
    var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
    j.async=true;
    j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
    f.parentNode.insertBefore(j,f);

    const ns = document.createElement('noscript');
    const ac = document.getElementById('app-content');
    const ns_tag = ac.parentNode.insertBefore(ns, ac);
    const ifrm = document.createElement('iframe');
    ifrm.src = 'https://www.googletagmanager.com/ns.html?id='+i;
    ifrm.height = 0;
    ifrm.width = 0;
    ifrm.style = 'display:none;visibility:hidden';
    ns_tag.appendChild(ifrm);
}

export default loadGoogleTagManager;
